import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import kebabCase from 'lodash/kebabCase';

@Directive({
    selector: '[sbTestSelector]',
    standalone: true
})
export class TestSelectorDirective implements AfterViewInit {
    get omitInnerText(): boolean {
        return this._omitInnerText;
    }

    @Input() set omitInnerText(value: boolean) {
        this._omitInnerText = value;
    }
    get context() {
        return this._context;
    }

    @Input('sbTestSelector') set context(value) {
        this._context = value;
    }

    get index() {
        return this._index as any;
    }
    @Input('sbTestIndex') set index(value: number) {
        this._index = '-' + value;
    }

    private _context = '';
    private _index = '';
    private _omitInnerText = false;
    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        const elementType = this.el.nativeElement.nodeName;
        const elementName =
            this.el.nativeElement.getAttribute('formcontrolname') ||
            this.el.nativeElement.getAttribute('formcontrol') ||
            this.el.nativeElement.getAttribute('name') ||
            this.el.nativeElement.getAttribute('aria-label') ||
            (this.omitInnerText ? '' : this.el.nativeElement.innerText);
        const id = this.el.nativeElement.getAttribute('id')
            ? (elementName ? '-' : '') + this.el.nativeElement.getAttribute('id')
            : '';
        const selector = kebabCase(
            `${this.context}-${elementType}-${elementName.trim()}${this.index}${id}`
        ).replace(/-$/, '');

        this.el.nativeElement.setAttribute('data-cy', selector);
    }
}
